import { z } from 'zod';

export const vendorRequestFormSchema = z.object({
  vendorName: z.string().trim().min(1, 'Pick your vendor organization.'),
  appName: z.string().optional(),
  contactName: z.string().trim().min(1, 'Enter a contact name.'),
  contactEmail: z
    .string()
    .trim()
    .min(1, 'Enter a contact email so we can reach them.')
    .email({ message: 'Invalid email format.' }),
  description: z.string().trim().min(1, 'Tell the vendor what you need protected.'),
});

export type IVendorRequestForm = z.infer<typeof vendorRequestFormSchema>;

export const vendorRequestFormDefaultValues: IVendorRequestForm = {
  vendorName: '',
  appName: '',
  contactName: '',
  contactEmail: '',
  description: '',
};
